// extracted by mini-css-extract-plugin
export default {"wrapper":"IssuesChartsByStatus_wrapper__oZY3x","barChart":"IssuesChartsByStatus_barChart__YhXvK"};